import { styled, StyledComponentProps } from '@material-ui/core';
import { ComponentProps, ComponentType } from 'react';

export const WbSidebarSpacer = styled('div')(
  {
    height: 16,
  },
  { name: 'WitboostSidebarSpacer' },
) as ComponentType<ComponentProps<'div'> & StyledComponentProps<'root'>>;
